<template>
  <div class="game-circle">
    <pageHeader title="游戏圈" />
    <div class="gray-box"></div>
    <div class="notice" :style="{position: isCollese ? 'absolute' : 'sticky'}">
      <div>
        <img src="@/assets/images/notice.png" alt="" />
        <span>活动公告：{{noticeInfo.title}}</span>
      </div>
      <div v-show="isCollese" class="notice-content" v-html="noticeInfo.content">
        
      </div>
      <div class="expend-btn" @click="isCollese = !isCollese">
        <img :src="isCollese ? require('@/assets/images/ic_share_about_close.png') : require('@/assets/images/arrow-down.png')" alt="" />
        <span>{{isCollese ? '收起':'查看'}}</span>
      </div>
    </div>
    <div @touchstart="isCollese = false">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="暂无更多数据"
      @load="onLoad"
      
    >
      <div class="game-circle-list">
        <div
          class="game-circle-list-item"
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="item-title">
            <div class="logo-title">
              <img :src="item.logoUrl" alt="" />
              <div>
                <h1>{{ item.name }}</h1>
                <span>{{ item.modifyTime }}</span>
              </div>
            </div>
            <div class="title-operate" @click="goToDetail(item)">查看游戏</div>
          </div>

          <div>
            <p
              :class="[
                'game-circle-desc',
                !item.isExpanded ? 'overflow-text' : '',
              ]"
              :ref="`content`"
              v-html="item.content"
            ></p>
            <div class="expand-operate" @click="toggleExpand(item)">
              <img
                :src="
                  !item.isExpanded
                    ? require('@/assets/images/ic_detail_eight_down.png')
                    : require('@/assets/images/ic_detail_eight_up.png')
                "
                alt=""
              />
              <span>{{ !item.isExpanded ? "展开" : "收起" }}</span>
            </div>
          </div>

          <div class="game-video-box">
            <video
              class="game-video"
              controls
              :src="item.videoUrl"
              :poster="item.imgUrl"
            >
              <!-- <source src="shanghai.mp4" type="video/mp4"> -->
            </video>
          </div>
        </div>
      </div>
    </van-list>
    </div>
  </div>
</template>

<script>
import pageHeader from "@/components/PageHeader";
import { requestMethods } from "@m/api";
export default {
  components: {
    pageHeader,
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      totalCount: 0,
      currentPage: 1,
      pageSize: 10,
      isCollese: false,
      noticeInfo: {}
    };
  },
  mounted() {
    // this.getNewsCount()
  },
  methods: {
    /**
     * 查询游戏圈列表
     */
    async onLoad() {
      const { data, totalCount } = await this.gameListQr();

      const list = data.map((e) => {
        return {
          ...e,
          content: e.content.replace(/\n/g, "<br />"),
          isExpanded: false,
        };
      });

      this.list = [...this.list, ...list];
      this.totalCount = totalCount;
      this.totalPage = Math.ceil(this.totalCount / this.pageSize);
      // 数据全部加载完成
      if (this.currentPage >= this.totalPage) {
        this.finished = true;
      }
      this.currentPage += 1;

      this.loading = false;
    },

    async gameListQr() {
      try {
        const { data, totalCount } = await requestMethods(
          "/modules/news/news/getNewsList.htm",
          "post",
          {
            currentPage: this.currentPage,
            pageSize: this.pageSize,
          }
        );
        let list = []
        if(this.currentPage == 1 && data.length) {
          let noticeList = data.filter(e => e.type == 'NEWS')
          if(noticeList.length) {
            this.noticeInfo = noticeList[0]
            this.noticeInfo.content = this.noticeInfo.content.replace(/\n/g, "<br />")
          }
        } 
        let videoList = data.filter(e => e.type != 'NEWS')
        list = videoList

        return {
          data: list,
          totalCount: totalCount,
        };
      } catch (error) {
        this.$toast({
          message: error.message,
          position: "bottom",
        });
      }
    },

    async getNewsCount() {
      try {
        const { data } = await requestMethods(
          "/modules/news/news/getNewsCount.htm",
          "post",
          {
            searchParams: JSON.stringify({}),
          }
        );
      } catch (error) {
        this.$toast({
          message: error.message,
          position: "bottom",
        });
      }
    },

    checkLineCount(e, index) {
      this.$nextTick(() => {
        const element = this.$refs[`content`];
        if (Array.isArray(element) && element[index]) {
          const lineHeight = parseFloat(
            getComputedStyle(element[index]).lineHeight
          );
          const lines = element[index].scrollHeight / lineHeight;
          this.$set(this.list[index], "showExpandButton", lines > 3);
        }
      });
    },

    toggleExpand(item) {
      item.isExpanded = !item.isExpanded;
    },

    goToDetail(info) {
      this.$router.push({
        path: "/detail",
        query: {
          gameId: info.gameId,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.game-circle {
  background: #f5f5f5;

  .gray-box {
    background: #f5f5f5;
    width: 100%;
    height: 10px;
    position: sticky;
    top: 88px;
    z-index: 999;
  }

  .notice {
    width: 100%;
    // height: 60px;
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    padding: 0 30px;
    background: #fff;
    position: sticky;
    top: 98px;
    z-index: 999;

    div {
      display: flex;
      align-items: center;
      line-height: 60px;

      img {
        width: 30px;
        height: 30px;
        margin-right: 10px;
      }
      span {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 22px;
        color: #ff9b6d;
      }
    }
    .notice-content {
      background: #fff;
    }
    .expend-btn {
      display: flex;
      align-items: center;
      position: absolute;
      bottom: 0;
      right: 24px;
      img {
        width: 24px;
        height: 18px;
      }
      span {
        color: #a2a2a2;
      }
    }
  }

  .game-circle-list {
    padding: 30px;

    .game-circle-list-item {
      width: 690px;
      background: #fff;
      margin-bottom: 30px;
      box-shadow: 0px 2px 30px 0px rgba(0, 0, 0, 0.15);
      border-radius: 36px 36px 0px 0px;

      .item-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;
        padding-top: 30px;
      }

      .logo-title {
        display: flex;
        align-items: center;

        img {
          width: 90px;
          height: 90px;
          border-radius: 50%;
          margin-right: 30px;
        }

        h1 {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 32px;
          color: #000000;
          line-height: 45px;
          width: 330px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        span {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 24px;
          color: #bbbbbb;
          line-height: 33px;
        }
      }

      .title-operate {
        width: 170px;
        height: 50px;
        border-radius: 40px;
        border: 2px solid #ff7a3e;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 26px;
        color: #ff7a3e;
        line-height: 50px;
        text-align: center;
      }

      .game-circle-desc {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 26px;
        color: #414141;
        padding: 30px 20px 0 20px;
        line-height: 37px;
      }

      .overflow-text {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .expand-operate {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-right: 20px;
        margin-top: 10px;

        img {
          width: 24px;
          height: 18px;
          margin-right: 10px;
        }
        span {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 26px;
          color: #ff7a3e;
        }
      }

      .game-video-box {
        width: 690px;
        height: 387px;
        margin-top: 30px;
      }
      .game-video {
        width: 690px;
        height: 387px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/gameCircle/index.vue